import { jsx, Fragment } from 'react/jsx-runtime';
import { IS_EMBEDDED } from '@sketch/constants';

/**
 * Only renders its children when the app is in an embedded context.
 */
const IsEmbedded = props => IS_EMBEDDED ? jsx(Fragment, { children: props.children }) : null;

export { IsEmbedded };
